import { Phone, MessageCircle, MapPin, ArrowDown } from "lucide-react";
import { telLink, waLink, HERO_BG } from "../../lib/constants";

export default function Hero() {
  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative min-h-[100vh] flex items-end overflow-hidden grain"
    >
      {/* Background image */}
      <div className="absolute inset-0 z-0">
        <img
          src={HERO_BG}
          alt="Justudy Library interior — silent study space in Noida"
          className="w-full h-full object-cover"
          style={{ objectPosition: "center 30%" }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/95 via-black/85 to-black/55" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0F0F0F] via-[#0F0F0F]/40 to-[#0F0F0F]/70" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-8 pb-24 pt-32 md:pb-32">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 mb-6 px-3 py-1.5 border border-[#FACC15]/40 bg-[#FACC15]/5 rounded-full">
            <span className="w-1.5 h-1.5 bg-[#FACC15] rounded-full animate-pulse" />
            <span className="text-[10px] tracking-[0.25em] uppercase text-[#FACC15] font-semibold">
              Noida · Sector 22 & 26
            </span>
          </div>

          <h1
            data-testid="hero-h1"
            className="sr-only"
          >
            Best Study Library in Noida — Justudy Library &amp; Co-working Space, Sector 22 (24/7) &amp; Sector 26
          </h1>

          <p
            data-testid="hero-heading"
            aria-hidden="true"
            className="font-display text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-bold tracking-tighter leading-[0.95] text-white"
          >
            Your Focus.
            <br />
            <span className="text-[#FACC15] italic font-light">Our Space.</span>
          </p>

          <p
            data-testid="hero-subheading"
            className="mt-8 text-base sm:text-lg text-white/70 max-w-xl leading-relaxed"
          >
            Silent, comfortable & productive{" "}
            <strong className="text-white">study library in Noida</strong> —{" "}
            with branches at{" "}
            <strong className="text-white">Sector 22</strong> (open 24/7) and{" "}
            <strong className="text-white">Sector 26</strong>. Built for serious
            students, UPSC aspirants and focused professionals.
          </p>

          <div className="mt-10 flex flex-wrap gap-3">
            <a
              href={telLink}
              data-testid="hero-call-btn"
              className="inline-flex items-center gap-2 bg-[#FACC15] hover:bg-[#EAB308] text-[#0F0F0F] font-semibold px-6 py-3.5 rounded-sm transition-all hover:-translate-y-1 hover:shadow-xl hover:shadow-[#FACC15]/20"
            >
              <Phone className="w-4 h-4" />
              Call Now
            </a>
            <a
              href={waLink()}
              target="_blank"
              rel="noreferrer"
              data-testid="hero-whatsapp-btn"
              className="inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#1EBE5C] text-white font-semibold px-6 py-3.5 rounded-sm transition-all hover:-translate-y-1"
            >
              <MessageCircle className="w-4 h-4" />
              WhatsApp Us
            </a>
            <a
              href="#branches"
              data-testid="hero-branches-btn"
              className="inline-flex items-center gap-2 border border-white/25 hover:border-[#FACC15] hover:text-[#FACC15] text-white font-medium px-6 py-3.5 rounded-sm transition-colors"
            >
              <MapPin className="w-4 h-4" />
              View Branches
            </a>
          </div>

          {/* Stats / micro-trust */}
          <div className="mt-16 grid grid-cols-3 gap-6 max-w-xl">
            {[
              { v: "2", l: "Noida Branches" },
              { v: "24/7", l: "Sector 22" },
              { v: "100%", l: "Silent Zones" },
            ].map((s) => (
              <div key={s.l} className="border-l border-white/10 pl-4">
                <div className="font-display text-3xl text-[#FACC15] font-semibold">
                  {s.v}
                </div>
                <div className="text-xs text-white/50 mt-1 tracking-wide uppercase">
                  {s.l}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* scroll indicator */}
      <a
        href="#branches"
        className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 text-white/40 hover:text-[#FACC15] transition-colors hidden md:flex flex-col items-center gap-2"
      >
        <span className="text-[10px] uppercase tracking-[0.3em]">Scroll</span>
        <ArrowDown className="w-4 h-4 animate-bounce" />
      </a>
    </section>
  );
}
